/***
 *
 *   SIGN UP STEP 1 — account
 *   Phase 9 — signup chrome + step indicator. Keep the 4 routes.
 *
 **********/

import React, { useContext } from 'react';
import { Animate, Form, Link, ProgressSteps } from 'components/lib';
import { AuthPage } from 'components/auth/authPage';
import { AuthContext } from 'app/auth';
import { useTranslate } from 'app/translations';

const STEPS = (t) => [
    { key: 'account', name: t('user.create.label'), icon: 'user', completed: false },
    { key: 'plan', name: t('plan.label'), icon: 'credit-card', completed: false },
];

export function Signup(props) {
    const { _t } = useTranslate();
    const context = useContext(AuthContext);

    return (
        <Animate type="pop">
            <AuthPage
                title={_t('user.create.title')}
                description={_t('signup.description')}
                footer={
                    <>
                        {_t('signup.already')} <Link url="/signin" text={_t('signin.label')} />
                    </>
                }>
                <ProgressSteps items={STEPS(_t)} current={0} />

                <Form
                    data={{
                        first_name: {
                            label: _t('firstName.label'),
                            value: '',
                            type: 'text',
                            required: true,
                            errorMessage: _t('firstName.empty'),
                        },
                        last_name: {
                            label: _t('lastName.label'),
                            value: '',
                            type: 'text',
                            required: true,
                            errorMessage: _t('lastName.empty'),
                        },
                        email: {
                            label: _t('email.label'),
                            type: 'email',
                            required: true,
                        },
                        password: {
                            label: _t('password.label'),
                            type: 'password',
                            required: true,
                            complexPassword: true,
                        },
                        confirm_password: {
                            type: 'hidden',
                            value: null,
                        },
                    }}
                    url="/api/account"
                    method="POST"
                    auth={false}
                    buttonText={_t('user.create.label')}
                    callback={context.signin}
                />
            </AuthPage>
        </Animate>
    );
}
